<template>
  <b-row class="h-100">
    <b-colxx xxs="12" md="5" class="mx-auto my-auto">
      <b-card style="padding: 10px 30px 30px;" no-body>
        <div class="position-relative image-side">
          <p class="text-white h2">
            Brand Admin Manager
          </p>
        </div>
        <div class="form-side">
          <h6 class="mb-4">{{ $t('user.forgot-password') }}</h6>
          <!--          <b-tabs content-class="mt-3" active-nav-item-class="font-weight-bold text-uppercase text-danger"-->
          <!--                  active-tab-class="font-weight-bold text-success">-->
          <!--            <b-tab title="이메일로 찾기" @click="resetForm">-->
          <!--              <find-by-email :data="form" @findFunction="findByEmail" _mode ='password' />-->
          <!--            </b-tab>-->
          <!--            <b-tab title="휴대전화 번호로 찾기" @click="resetForm">-->
          <!--              <find-by-phone :data="form" @findFunction="findByPhone" _mode ='password'/>-->
          <!--            </b-tab>-->
          <!--          </b-tabs>-->

          <find-by-phone :data="form" @findPasswordOtp="findPasswordOtp" @findPasswordLogin="findPasswordLogin"
                         _mode='password'/>

        </div>
      </b-card>
    </b-colxx>
  </b-row>
</template>

<script>
import {
  mapGetters,
  mapActions
} from "vuex";

import FindByEmail from './components/FindByEmail'
import FindByPhone from './components/FindByPhoneNumber'
import api from '../../constants/api'

export default {
  components: {
    'find-by-email': FindByEmail,
    'find-by-phone': FindByPhone
  },
  data() {
    return {
      form: {
        username: this.$route.params.id !== undefined ? this.$route.params.id : null,
        fullName: null,
        phoneNumber: null,
        password: '',
        passwordConfirm: ''
      }
    };
  },
  computed: {
    ...mapGetters(["processing", "siteName","currentUser"])
  },
  methods: {
    ...mapActions(["otpLogin","setBrandInfo"]),

    findPasswordOtp(username, phoneNumber) {

      const reqURL = api.changeAPI(this.siteName, api.basicURL + api.user.findPassOtp)
      const params = {username: username, phoneNumber: phoneNumber}

      this.$http.post(reqURL, params).then(res => {
        if(res.data.code === "OK") {
          ;
        } else {
          throw 400
        }
      }).catch(err => {
        alert(err.response.data.message);
      })

    },

    findPasswordLogin(username, otp) {

      const reqURL = api.changeAPI(this.siteName, api.basicURL + api.user.findPassLogin)
      const params = {username: username, otp: otp
      }
      this.$http.post(reqURL, params).then(res => {
        if(res.data.code === "OK") {
          ;
          if(res.data.code =="OK"){
            this.otpLogin({data : res.data.data});
          }

        } else {
          throw 400
        }
      }).catch(err => {
        alert(err.response.data.message);
      })

    },


    resetForm() {
      this.form.username = this.$route.params.id !== undefined ? this.$route.params.id : null
      this.form.fullName = null
      this.form.phoneNumber = null
    }
  },
  watch: {
    currentUser(val) {

      if (val.tokens.access.token && val.tokens.access.token !== "") {
        this.setBrandInfo()
        setTimeout(() => {
          this.$router.push("/" + this.$route.params.sitename);
        }, 200);
      }
    },

  }
};
</script>
